module.exports = __webpack_public_path__ + "media/images/Vector-c8de412f9cb0b488f5a9e50a2a5d0733.png";